var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOverviewMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#00CC99",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 30.8281H36V18.1719H12V30.8281ZM20.4844 20.2812C20.4844 20.0148 20.6354 19.7719 20.8729 19.6523C21.1106 19.5342 21.3975 19.5589 21.609 19.7189L27.234 23.9377C27.4113 24.0701 27.5156 24.2788 27.5156 24.5C27.5156 24.7212 27.4113 24.9299 27.234 25.0623L21.609 29.2811C21.4854 29.3745 21.3371 29.4219 21.1875 29.4219C21.0804 29.4219 20.9718 29.3972 20.8729 29.3477C20.6354 29.2281 20.4844 28.9852 20.4844 28.7188V20.2812Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7031 32.2344H28.9219V35.0469H24.7031V32.2344Z",
    fill: "#00CC99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 32.2344H23.2969V35.0469H19.0781V32.2344Z",
    fill: "#00CC99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8906 13.9531H30.3281V16.7656H36V16.0625C36 14.8994 35.0537 13.9531 33.8906 13.9531Z",
    fill: "#00CC99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 21.6875V27.3125L25.6412 24.5L21.8906 21.6875Z",
    fill: "#00CC99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 13.9531H23.2969V16.7656H19.0781V13.9531Z",
    fill: "#00CC99"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 32.9375C12 34.1006 12.9463 35.0469 14.1094 35.0469H17.6719V32.2344H12V32.9375Z",
    fill: "#00CC99"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7031 13.9531H28.9219V16.7656H24.7031V13.9531Z",
    fill: "#00CC99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3281 35.0469H33.8906C35.0537 35.0469 36 34.1006 36 32.9375V32.2344H30.3281V35.0469Z",
    fill: "#00CC99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 13.9531H14.1094C12.9463 13.9531 12 14.8994 12 16.0625V16.7656H17.6719V13.9531Z",
    fill: "#00CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverviewMedia);
export default __webpack_public_path__ + "static/media/ICON_OVERVIEW_MEDIA.42977706ff56e519c8a043799e46335e.svg";
export { ForwardRef as ReactComponent };